/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type CarePlanFollowUpDurationUnit =
  (typeof CarePlanFollowUpDurationUnit)[keyof typeof CarePlanFollowUpDurationUnit];

export const CarePlanFollowUpDurationUnit = {
  hours: "hours",
  days: "days",
  weeks: "weeks",
} as const;
